import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";
import { getLineKey } from "../../utils/generalUtils";
import { loadCart } from "../localStorage";

const MAX_QUANTITY = 20;

/* State shape
{
  //options: the chosen product options, e.g. { Color: "Gold" } - the same product with other options is another line
  items: [{ sku, options, quantity }],
  drawerOpen: bool,
}
*/
const initialState = {
  items: loadCart(),
  drawerOpen: false,
};

const addItem = (state, action) => {
  const key = getLineKey(action.sku, action.options);
  const existing = state.items.find((x) => getLineKey(x.sku, x.options) === key);
  if (existing) {
    return updateObject(state, {
      items: state.items.map((x) => (
        (x === existing) ? { ...x, quantity: Math.min(x.quantity + action.quantity, MAX_QUANTITY) } : x
      )),
    });
  }
  return updateObject(state, {
    items: [...state.items, { sku: action.sku, options: action.options, quantity: action.quantity }],
  });
};

const setQuantity = (state, action) => {
  if (action.quantity < 1) {
    return removeItem(state, action);
  }
  return updateObject(state, {
    items: state.items.map((x) => (
      (getLineKey(x.sku, x.options) === action.key) ? { ...x, quantity: Math.min(action.quantity, MAX_QUANTITY) } : x
    )),
  });
};

const removeItem = (state, action) => (
  updateObject(state, {
    items: state.items.filter((x) => getLineKey(x.sku, x.options) !== action.key),
  })
);

const removeUnavailable = (state, action) => (
  updateObject(state, {
    items: state.items.filter(action.isAvailable),
  })
);

const clear = (state) => (
  updateObject(state, {
    items: [],
  })
);

const setDrawerOpen = (state, action) => (
  updateObject(state, {
    drawerOpen: action.isOpen,
  })
);

const reducer = createReducer(initialState, {
  [actionType.ADD_ITEM]: addItem,
  [actionType.SET_QUANTITY]: setQuantity,
  [actionType.REMOVE_ITEM]: removeItem,
  [actionType.REMOVE_UNAVAILABLE]: removeUnavailable,
  [actionType.CLEAR]: clear,
  [actionType.SET_DRAWER_OPEN]: setDrawerOpen,
});

export default reducer;

// SELECTORS
export const getItems = (state) => (
  state.items
);

export const getDrawerOpen = (state) => (
  state.drawerOpen
);
